import * as Yup from 'yup';

import { UuidableName } from 'utils/api/types';
import { PersonalDetailsResponse } from 'utils/api/modules/user/user.types';

export interface PersonalInformationFormValues {
  name: string;
  email: string;
  phoneNumber: string | null;
  employeeId: string;
  personalDetails: PersonalDetailsResponse;
  groups: UuidableName[];
}

export const EditPersonalInformationSchema = (showSafety: boolean) => {
  const phoneNumber = showSafety
    ? {
        phoneNumber: Yup.string().required(
          'Phone number is required when the lone working mobile app is enabled on the Manage page.'
        ),
      }
    : {};
  // @ts-ignore
  return Yup.object().shape({
    ...phoneNumber,
    name: Yup.string().required('Name is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    employeeId: Yup.string().max(128, 'Employee ID is too long'),
  });
};
